<span class="node" [class]="'n-' + categoryClass()"></span>

<div class="body">
    <div class="line1">{{ humanizedDetail() }}</div>

    <div class="meta">
        @if (event().user?.name) {
            <span class="who">
                <ra-user-avatar [user]="actorUser()" [avatarSize]="18" />
                {{ event().user?.name }}
            </span>
        } @else {
            <span class="who muted">{{ 'audit.list.system' | translate }}</span>
        }
        <span class="t">{{ event().createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
    </div>

    @if (hasDiff()) {
        <button class="see-diff" type="button" (click)="onDiff($event)">
            <ra-icon [icon]="'edit-2'" [varColor]="'accentBlue'" [size]="12" />
            {{ 'document.edit.history.viewDiff' | translate }}
        </button>
    }
</div>
